import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@svs/ui/react/skeleton';
import type { ReactNode } from 'react';

/**
 * Skeleton fallback for GameAnalysisOutcome while loading.
 *
 * @returns skeleton loading row for outcome predictions
 */
export function GameAnalysisOutcomeFallback() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <td className="w-full"><Skeleton className="h-8 w-full rounded-full" /></td>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <td className="w-full"><Skeleton className="h-8 w-full rounded-full" /></td>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <tr className="flex w-full justify-between gap-x-1.5 text-center">{t0}{t1}<td className="w-full"><Skeleton className="h-8 w-full rounded-full" /></td></tr>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}